var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { b2cAccountApi } from '../api/b2c/account';
import { useGetRecaptchaToken } from '../hooks/use-get-recaptcha-token';
import { RecaptchaAction } from '../constants/recaptcha';
export var ExperienceFlows;
(function (ExperienceFlows) {
    ExperienceFlows["NEW_ENROLLMENT"] = "NEW_ENROLLMENT";
    ExperienceFlows["ADD_ADDRESS"] = "ADD_ADDRESS";
    ExperienceFlows["ADD_PAYMENT"] = "ADD_PAYMENT";
    ExperienceFlows["EDIT_PAYMENT"] = "EDIT_PAYMENT";
    ExperienceFlows["EDIT_ADDRESS"] = "EDIT_ADDRESS";
    ExperienceFlows["SELECT_PAYMENT"] = "SELECT_PAYMENT";
    ExperienceFlows["SELECT_ADDRESS"] = "SELECT_ADDRESS";
    ExperienceFlows["RE_ENROLLMENT"] = "RE_ENROLMENT";
})(ExperienceFlows || (ExperienceFlows = {}));
const InstantCheckoutContext = React.createContext(null);
const InstantCheckoutProvider = ({ children, }) => {
    const [isEnrolled, setIsEnrolled] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [accountData, setAccountData] = useState(null);
    const isRecaptchaEnabled = !!useConfigService('B2C_PROFILE_INVISIBLE_RECAPTCHA_ENABLED');
    const { getRecaptchaToken } = useGetRecaptchaToken(isRecaptchaEnabled);
    const updatePersonalDetails = (requestData) => __awaiter(void 0, void 0, void 0, function* () {
        const token = yield getRecaptchaToken(RecaptchaAction.B2C_UPDATE_PERSONAL_DETAILS);
        return b2cAccountApi.updateProfileDetails(requestData, token);
    });
    const getProfileData = () => {
        return b2cAccountApi.profileDetails().then(({ data }) => {
            setAccountData(data);
            setIsEnrolled(data.account.profile.enableInstantCheckout === 'Y');
        });
    };
    return (React.createElement(InstantCheckoutContext.Provider, { value: {
            isEnrolled,
            setIsEnrolled,
            alertMessage,
            setAlertMessage,
            accountData,
            setIsLoading,
            isLoading,
            updatePersonalDetails,
            getProfileData,
        } }, children));
};
export { InstantCheckoutProvider, InstantCheckoutContext };
